import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { injectIntl } from 'react-intl-next';
import { TRIGGER_METHOD } from '@atlaskit/editor-common/analytics';
import { ArrowKeyNavigationType, Dropdown } from '@atlaskit/editor-common/ui-menu';
import { akEditorFloatingPanelZIndex } from '@atlaskit/editor-shared-styles';
import { Box, xcss } from '@atlaskit/primitives';
import FindReplace from './FindReplace';
var findReplaceWrapperStyles = xcss({
  display: 'flex',
  flexDirection: 'column'
});

// Magic number taken from ../FindReplaceToolbarButton.tsx
var dropdownWidthNewDesign = 382;
var FindReplaceDropdown = function FindReplaceDropdown(props) {
  var findText = props.findText,
    replaceText = props.replaceText,
    isActive = props.isActive,
    index = props.index,
    numMatches = props.numMatches,
    popupsMountPoint = props.popupsMountPoint,
    onCancel = props.onCancel;
  if (!popupsMountPoint) {
    return null;
  }
  return /*#__PURE__*/React.createElement(Dropdown, {
    target: popupsMountPoint,
    mountTo: popupsMountPoint,
    forcePlacement: true,
    alignX: 'right',
    alignY: 'start',
    offset: [4, 0],
    isOpen: isActive,
    handleEscapeKeydown: function handleEscapeKeydown() {
      if (isActive) {
        onCancel({
          triggerMethod: TRIGGER_METHOD.KEYBOARD
        });
      }
    },
    fitWidth: dropdownWidthNewDesign,
    zIndex: akEditorFloatingPanelZIndex,
    arrowKeyNavigationProviderOptions: {
      type: ArrowKeyNavigationType.MENU,
      disableArrowKeyNavigation: true
    }
  }, /*#__PURE__*/React.createElement(Box, {
    xcss: findReplaceWrapperStyles
  }, /*#__PURE__*/React.createElement(FindReplace, _extends({
    findText: findText,
    replaceText: replaceText,
    count: {
      index: index,
      total: numMatches
    }
    // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
  }, props))));
};
export default injectIntl(FindReplaceDropdown);